import { render, staticRenderFns } from "./SponsoredRecommendationTitleList.vue?vue&type=template&id=03ffea63&scoped=true"
import script from "./SponsoredRecommendationTitleList.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsoredRecommendationTitleList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SponsoredRecommendationTitleList.vue?vue&type=style&index=0&id=03ffea63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ffea63",
  null
  
)

export default component.exports